import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BsModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { BusyModule } from 'angular2-busy';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PaperTemplateModule } from '../../shared/modules/paper-template.module';
import { Ng2Webstorage } from 'ngx-webstorage';
import { PaperSetsComponent } from './components/paper-sets.component';
import { MainComponent } from './components/main.component';
import { PapersComponent } from './components/papers.component';
import { PaperPartsComponent } from './components/paper-parts.component';
// import { examsRouting, examsRoutingProviders } from './paper-set.routes';
import { AddCartComponent } from '../add-cart/components/add-cart.component';

import { PaperComponent } from './components/paper.component';


import { RedirectComponent } from './components/redirect.component';

import { LoaderComponent, BackButtonService } from '../../shared/';
import { SharedModule } from "../../shared/shared.module";
import { PaperSetComponent } from './components/paper-set.component';
import { DynamicClassPipe } from '../../shared/pipe/dynamic-class.pipe';


//import { pap, homeRoutingProviders } from './paper-sets.routes';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    FormsModule,
    ToastModule,
    BusyModule,
    SharedModule,
    Ng2Webstorage,
    PaperTemplateModule,
    InfiniteScrollModule
  ],
  declarations: [
    PaperSetsComponent, 
    MainComponent, 
    PapersComponent, 
    PaperPartsComponent, 
    PaperComponent,
    RedirectComponent,
    LoaderComponent,
    DynamicClassPipe,
    AddCartComponent,
    PaperSetComponent
    ],

  providers : [BackButtonService],
  exports : [
    PaperSetComponent
  ]
})
export class PaperSetsModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/paper-sets.module.ts